/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  StorageBindingResponse,
  UpsertStorageBindingDefaultRequest,
  UpsertStorageBindingInstanceRequest,
} from '../models/index';
import {
    StorageBindingResponseFromJSON,
    StorageBindingResponseToJSON,
    UpsertStorageBindingDefaultRequestFromJSON,
    UpsertStorageBindingDefaultRequestToJSON,
    UpsertStorageBindingInstanceRequestFromJSON,
    UpsertStorageBindingInstanceRequestToJSON,
} from '../models/index';

export interface ClearDefaultRequest {
    tenantId: string;
    purpose: ClearDefaultPurposeEnum;
    sessionId?: string;
}

export interface DeleteBindingRequest {
    tenantId: string;
    bindingId: string;
    sessionId?: string;
}

export interface ListBindingsRequest {
    tenantId: string;
    sessionId?: string;
}

export interface UpsertDefaultRequest {
    tenantId: string;
    upsertStorageBindingDefaultRequest: UpsertStorageBindingDefaultRequest;
    sessionId?: string;
}

export interface UpsertInstanceOverrideRequest {
    tenantId: string;
    integrationInstanceId: string;
    upsertStorageBindingInstanceRequest: UpsertStorageBindingInstanceRequest;
    sessionId?: string;
}

/**
 * TenantStorageBindingsApi - interface
 * 
 * @export
 * @interface TenantStorageBindingsApiInterface
 */
export interface TenantStorageBindingsApiInterface {
    /**
     * 
     * @summary Clear tenant default binding for a purpose (revert to platform-managed storage)
     * @param {string} tenantId 
     * @param {'INTEGRATION_PIPELINE' | 'SECURE_FILES'} purpose 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantStorageBindingsApiInterface
     */
    clearDefaultRaw(requestParameters: ClearDefaultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Clear tenant default binding for a purpose (revert to platform-managed storage)
     */
    clearDefault(requestParameters: ClearDefaultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Delete a storage binding
     * @param {string} tenantId 
     * @param {string} bindingId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantStorageBindingsApiInterface
     */
    deleteBindingRaw(requestParameters: DeleteBindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Delete a storage binding
     */
    deleteBinding(requestParameters: DeleteBindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary List storage bindings for tenant
     * @param {string} tenantId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantStorageBindingsApiInterface
     */
    listBindingsRaw(requestParameters: ListBindingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List storage bindings for tenant
     */
    listBindings(requestParameters: ListBindingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Set or update tenant default storage binding for a purpose
     * @param {string} tenantId 
     * @param {UpsertStorageBindingDefaultRequest} upsertStorageBindingDefaultRequest 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantStorageBindingsApiInterface
     */
    upsertDefaultRaw(requestParameters: UpsertDefaultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageBindingResponse>>;

    /**
     * Set or update tenant default storage binding for a purpose
     */
    upsertDefault(requestParameters: UpsertDefaultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageBindingResponse>;

    /**
     * 
     * @summary Set integration instance storage binding override
     * @param {string} tenantId 
     * @param {string} integrationInstanceId 
     * @param {UpsertStorageBindingInstanceRequest} upsertStorageBindingInstanceRequest 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantStorageBindingsApiInterface
     */
    upsertInstanceOverrideRaw(requestParameters: UpsertInstanceOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageBindingResponse>>;

    /**
     * Set integration instance storage binding override
     */
    upsertInstanceOverride(requestParameters: UpsertInstanceOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageBindingResponse>;

}

/**
 * 
 */
export class TenantStorageBindingsApi extends runtime.BaseAPI implements TenantStorageBindingsApiInterface {

    /**
     * Clear tenant default binding for a purpose (revert to platform-managed storage)
     */
    async clearDefaultRaw(requestParameters: ClearDefaultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling clearDefault().'
            );
        }

        if (requestParameters['purpose'] == null) {
            throw new runtime.RequiredError(
                'purpose',
                'Required parameter "purpose" was null or undefined when calling clearDefault().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{tenantId}/storage/bindings/defaults/{purpose}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));
        urlPath = urlPath.replace(`{${"purpose"}}`, encodeURIComponent(String(requestParameters['purpose'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Clear tenant default binding for a purpose (revert to platform-managed storage)
     */
    async clearDefault(requestParameters: ClearDefaultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.clearDefaultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a storage binding
     */
    async deleteBindingRaw(requestParameters: DeleteBindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteBinding().'
            );
        }

        if (requestParameters['bindingId'] == null) {
            throw new runtime.RequiredError(
                'bindingId',
                'Required parameter "bindingId" was null or undefined when calling deleteBinding().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{tenantId}/storage/bindings/{bindingId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));
        urlPath = urlPath.replace(`{${"bindingId"}}`, encodeURIComponent(String(requestParameters['bindingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a storage binding
     */
    async deleteBinding(requestParameters: DeleteBindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deleteBindingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List storage bindings for tenant
     */
    async listBindingsRaw(requestParameters: ListBindingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling listBindings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{tenantId}/storage/bindings`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List storage bindings for tenant
     */
    async listBindings(requestParameters: ListBindingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listBindingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set or update tenant default storage binding for a purpose
     */
    async upsertDefaultRaw(requestParameters: UpsertDefaultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageBindingResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling upsertDefault().'
            );
        }

        if (requestParameters['upsertStorageBindingDefaultRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertStorageBindingDefaultRequest',
                'Required parameter "upsertStorageBindingDefaultRequest" was null or undefined when calling upsertDefault().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/tenants/{tenantId}/storage/bindings/defaults`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertStorageBindingDefaultRequestToJSON(requestParameters['upsertStorageBindingDefaultRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StorageBindingResponseFromJSON(jsonValue));
    }

    /**
     * Set or update tenant default storage binding for a purpose
     */
    async upsertDefault(requestParameters: UpsertDefaultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageBindingResponse> {
        const response = await this.upsertDefaultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set integration instance storage binding override
     */
    async upsertInstanceOverrideRaw(requestParameters: UpsertInstanceOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageBindingResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling upsertInstanceOverride().'
            );
        }

        if (requestParameters['integrationInstanceId'] == null) {
            throw new runtime.RequiredError(
                'integrationInstanceId',
                'Required parameter "integrationInstanceId" was null or undefined when calling upsertInstanceOverride().'
            );
        }

        if (requestParameters['upsertStorageBindingInstanceRequest'] == null) {
            throw new runtime.RequiredError(
                'upsertStorageBindingInstanceRequest',
                'Required parameter "upsertStorageBindingInstanceRequest" was null or undefined when calling upsertInstanceOverride().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/tenants/{tenantId}/storage/bindings/instances/{integrationInstanceId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));
        urlPath = urlPath.replace(`{${"integrationInstanceId"}}`, encodeURIComponent(String(requestParameters['integrationInstanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertStorageBindingInstanceRequestToJSON(requestParameters['upsertStorageBindingInstanceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StorageBindingResponseFromJSON(jsonValue));
    }

    /**
     * Set integration instance storage binding override
     */
    async upsertInstanceOverride(requestParameters: UpsertInstanceOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageBindingResponse> {
        const response = await this.upsertInstanceOverrideRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ClearDefaultPurposeEnum = {
    IntegrationPipeline: 'INTEGRATION_PIPELINE',
    SecureFiles: 'SECURE_FILES'
} as const;
export type ClearDefaultPurposeEnum = typeof ClearDefaultPurposeEnum[keyof typeof ClearDefaultPurposeEnum];
